import { extractDateFormat } from 'element-plus'
import request from '~/request/index.js'


/**
 * Query recruitment demand list
 * GET /api/v1/business/recruitment/list
 * API ID: 218947435
 * API URL: https://app.apifox.com/link/project/5047271/apis/api-218947435
 */
export const getRecruitmentListApi = (positionId, pageSize, pageNum, finished,createBy, processTemplateId, requesterUserId, filter) => {
    const params = {
        // isAsc: 'desc',
        // orderByColumn: 'createTime',
        archived: 1
    }
    if (positionId !== null && positionId !== undefined && positionId !== 'undefined') {
        if (positionId === '') {
            params.positionIdIsNull = true
        } else {
            params.positionId = positionId
        }
    }

    if (pageSize) {
        params.pageSize = pageSize
    }

    if (pageNum) {
        params.pageNum = pageNum
    }

    if (finished || finished === 0) {
        params.finishFlag = finished
    }
    if(createBy){
        params.createBy = createBy
    }
    if (processTemplateId) {
        params.processTemplateId = processTemplateId
    }
    if (requesterUserId) {
        params.requesterUserId = requesterUserId
    }
    if (filter?.recruitmentTitle) {
        params.name = filter.recruitmentTitle
    }
    if (filter?.followerUserId) {
        params.followerUserId = filter.followerUserId
    }
    return request.get('/api/v1/business/recruitment/list', { params })
}

/**
 * 查询自己创建的面试方案列表
  GET /api/v1/business/recruitment/list-by-owner
  接口ID：244728712
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-244728712
 */
  export const getMyDemandApi = (userId) => request.get(`/api/v1/business/recruitment/list?createBy=${userId}`)

  /**
   * 查询自己创建的面试方案数量
   */
  export const getMyDemandCountApi = (userId) => {
    const params = {}
    if (userId) {
      params.createBy = userId
    }
    return request.get('/api/v1/business/recruitment/count', { params })
  }
/**
 * 新增面试方案
  POST /api/v1/business/recruitment
  接口ID：218947437
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-218947437
 */
export const addRecruitmentApi = (data) => request.post(`/api/v1/business/recruitment`,data)

/**
 * 修改需求
  PUT /api/v1/business/recruitment
  接口ID：218947438
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-218947438
 */
export const editRecruitmentApi = (data) => request.put(`/api/v1/business/recruitment`,data)

/**
 * 获取面试方案详细信息
  GET /api/v1/business/recruitment/{id}
  接口ID：218947436
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-218947436
 */
export const getRecruitmentMainApi = (id) => request.get(`/api/v1/business/recruitment/${id}`)

/**
 * 删除面试方案
  DELETE /api/v1/business/recruitment/{ids}
  接口ID：218947439
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-218947439
 */
export const delRecruitmentItemApi = (ids) => request.delete(`/api/v1/business/recruitment/${ids}`)

/**
 * 通过画像ID查面试方案
 * @param {*} positionProfileId 
 * @returns 
 */
export const getRecruitmentPositionListApi = (positionProfileId) => request.get(`/api/v1/business/recruitment/list?positionProfileId=${positionProfileId}`)
/**
 * 查询自己的外部临时同步列表
 *   GET /api/v1/business/job-sync-temp/list-by-owner
 *   接口ID：237946557
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-237946557
 */
export const getJobSyncTempListApi = () => request.get(`/api/v1/business/job-sync-temp/list-by-owner`)
/**
 * 删除自己的外部临时同步列表
 *   DELETE /api/v1/business/job-sync-temp/owner
 *   接口ID：237946919
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-237946919
 */
export const delJobSyncTempListApi = () => request.delete(`/api/v1/business/job-sync-temp/owner`)

/**
 * 外部临时职位同步到系统面试方案
 *   POST /api/v1/business/job-sync-temp/temp-to-recruitment
 *   接口ID：238624546
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-238624546
 */
export const tempToRecruitmentApi = (data) => request.post(`/api/v1/business/job-sync-temp/temp-to-recruitment`,data)

/**
 * 完成面试方案
 *   PATCH /api/v1/business/recruitment/finish
 *   接口ID：238264512
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-238264512
 */
export const finishRecruitmentApi = (data) => request.patch(`/api/v1/business/recruitment/finish-status`,data)


/**
 * 获取面试方案详细信息
 *   GET /api/v1/business/recruitment/{id}
 *   接口ID：218947436
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-218947436
 */
export const getRecruitmentMainNByIdApi = (id) => request.get(`/api/v1/business/recruitment/${id}`)

/**
 * 获取面试方案关联的职位同步详细信息
 *   GET /api/v1/business/job-sync/{recruitmentId}
 *   接口ID：238912293
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-238912293
 */
export const getJobSyncMainApi = (recruitmentId) => request.get(`/api/v1/business/job-sync/recruitment/${recruitmentId}`)

/**
 * 获取同步结果
 *   GET /api/v1/business/job-sync-temp/sync-status
 *   接口ID：239949323
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-239949323
 */
export const getSyncStatusApi = () => request.get(`/api/v1/business/job-sync-temp/sync-status`)

/**
 * 缓存筛选条件
  POST /api/v1/business/recruitment/filter-item
  接口ID：265871681
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-265871681
 */
export const postFilterItemApi = (data) => request.post(`/api/v1/business/recruitment/filter-item`,data)

/**
 * 获取筛选条件缓存数据
  GET /api/v1/business/recruitment/filter-item
  接口ID：265872388
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-265872388
 */
export const getFilterItemApi = (jobSyncId,userId) => request.get(`/api/v1/business/job-sync/remote/${jobSyncId}`)

/**
 * 保存筛选项
  PATCH /api/v1/business/recruitment/filter-conditions
  接口ID：267551587
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-267551587
 */
export const patchFilterConditionsApi = (data) => request.patch(`/api/v1/business/recruitment/filter-conditions`,data)

/**
 * 启动远程任务
  POST /api/v1/business/remote-task
  接口ID：293991045
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-293991045
 */
export const createRemoteTaskApi = (data) => request.post(`/api/v1/business/remote-task`,data)

/**
 * 获取远程任务列表
  GET /api/v1/business/remote-task/list
  接口ID：293991046
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-293991046
 */
/**
 * 获取远程任务列表（根据需求ID）
 * @param {string|number} demandId - 需求ID
 * @param {Array<number>} taskStatusList - 任务状态列表，默认为[0,1]
 * @returns {Promise}
 */
export const getRemoteTaskListApi = (demandId, taskStatusList = [0, 1,5]) => {
    const params = {
        isAsc: 'desc',
        orderByColumn: 'createTime',
        jobSyncId: demandId,
        taskStatusList: taskStatusList.join(',')
    }
    return request.get('/api/v1/business/remote-task/list', { params })
}
export const getRemoteTaskListV2Api = (demandId, pageSize = 10, pageNum = 1) => {
    const params = {
        isAsc: 'desc',
        orderByColumn: 'createTime',
        jobSyncId: demandId,
        pageSize: pageSize,
        pageNum: pageNum
    }
    return request.get('/api/v1/business/remote-task/list', { params })
}

/**
 * 获取所有远程任务列表（根据创建者）
 * @param {string|number} createBy - 创建者ID
 * @param {Array<number>} taskStatusList - 任务状态列表，默认为[0,1]
 * @returns {Promise}
 */
export const getRemoteTaskAllListApi = (createBy, taskStatusList = [0, 1,5], taskType, pageSize = 10, pageNum = 1) => {
    const params = {
        isAsc: 'desc',
        orderByColumn: 'createTime',
        createBy: createBy,
    }
    if (taskStatusList) {
        params.taskStatusList = taskStatusList.join(',')
    }
    if (taskType !== undefined && taskType !== null && taskType !== '' && taskType !== 'undefined') {
        params.taskType = taskType
    }
    if (pageSize) {
        params.pageSize = pageSize
    }
    if (pageNum) {
        params.pageNum = pageNum
    }
    return request.get('/api/v1/business/remote-task/list', { params })
}

/**
 * 获取远程任务详细信息
  GET /api/v1/business/remote-task/{id}
  接口ID：295158853
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-295158853
 */
export const getRemoteTaskMainApi = (taskId) => request.get(`/api/v1/business/remote-task/${taskId}`)

/**
 * 根据同步需求任务继续执行找简历任务
  POST /api/v1/business/remote-task/resume
  接口ID：342125235
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-342125235
 */
export const patchRemoteTaskResumeApi = (data) => request.post(`/api/v1/business/remote-task/resume`,data)

/**
 * 根据需求id查找当前远程任务
  GET /api/v1/business/remote-task/recruitment/{recruitmentId}
  接口ID：318431422
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-318431422
 */
export const getRemoteTaskMainByRecruitmentApi = (recruitmentId) => request.get(`/api/v1/business/remote-task/recruitment/${recruitmentId}`)


/**
 * 修改远程任务
  PUT /api/v1/business/remote-task
  接口ID：293991047
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-293991047
 */
export const updateRemoteTaskApi = (data) => request.put(`/api/v1/business/remote-task`, data)


/**
 * 复制需求
  POST /api/v1/business/recruitment/copy/{recruitmentId}
  接口ID：306991682
  接口地址：https://app.apifox.com/link/project/6553325/apis/api-306991682
 */
export const copyRecruitmentTaskApi =(recruitmentId)=>request.post(`/api/v1/business/recruitment/copy/${recruitmentId}`);



/**
 * 导入简历判断标准标签
 * 
  GET /api/v1/business/recruitment/latest-by-position/{id}
  接口ID：307309853
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-307309853
 */

export const expRecruitmentLatestByPositionApi =(id)=>request.get(`/api/v1/business/recruitment/latest-by-position/${id}`);

/**
 * 查询远程任务日志列表
  GET /api/v1/business/remote-task-log/list
  接口ID：314945426
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-314945426
 */
export const getRemoteTaskLogApi =(id)=>request.get(`/api/v1/business/remote-task-log/list?remoteTaskId=${id}`);
/**
 * 查询远程任务日志列表
  GET /api/v1/business/remote-task-log/list
  接口ID：314945426
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-314945426
 */
export const getRemoteTaskLogBySessionIdApi =(sessionId)=>request.get(`/api/v1/business/remote-task-log/list?sessionId=${sessionId}`);
/**
 * 添加日志
 * @param {*} data 
 * @returns 
 */
export const addRemoteTaskLogApi =(data)=>request.post(`/api/v1/business/remote-task-log`,data);

/**
 * 远程获取面试方案详细信息
  GET /api/v1/business/recruitment/remote/{id}
  接口ID：321260208
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-321260208
 */
export const getRecruitmentRemoteMainApi =(id)=>request.get(`/api/v1/business/job-sync/remote/${id}`);

/**
 * 生成面试方案
  POST /api/v1/business/recruitment/interview-plan/generate
  接口ID：348109473
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-348109473
 */
export const generateInterviewPlanApi =(data)=>request.post(`/api/v1/business/recruitment/interview-plan/generate`,data);


/**
 * 生成查询关键词
  POST /api/v1/business/recruitment/{recruitmentId}/query-keywords/generate
  接口ID：350336744
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-350336744
 */
export const generateQueryKeywordsApi =(recruitmentId, arrayData)=>{
    if (arrayData && arrayData.length > 0) {
        return request.post(`/api/v1/business/recruitment/${recruitmentId}/query-keywords/generate`, arrayData);
    } else {
        return request.post(`/api/v1/business/recruitment/${recruitmentId}/query-keywords/generate`);
    }
};

/**
 * 生成简历筛选标准和打招呼消息
  POST /api/v1/business/recruitment/{recruitmentId}/standards-greeting/generate
  接口ID：350363007
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-350363007
 */
export const generateStandardsGreetingApi =(recruitmentId)=>request.post(`/api/v1/business/recruitment/${recruitmentId}/standards-greeting/generate`);

/**
 * 生成JD优化
  POST /api/v1/business/recruitment/{recruitmentId}/job-description/generate
  接口ID：350336746
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-350336746
 */
export const generateJobDescriptionApi =(recruitmentId, arrayData)=>{
    if (arrayData && arrayData.length > 0) {
        return request.post(`/api/v1/business/recruitment/${recruitmentId}/job-description/generate`, arrayData);
    } else {
        return request.post(`/api/v1/business/recruitment/${recruitmentId}/job-description/generate`);
    }
};


/**
 * 生成面试模板
  POST /api/v1/business/recruitment/{recruitmentId}/process-template/generate
  接口ID：350336747
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-350336747
 */
export const generateProcessTemplateApi =(recruitmentId, arrayData)=>{
    if (arrayData && arrayData.length > 0) {
        return request.post(`/api/v1/business/recruitment/${recruitmentId}/process-template/generate`, arrayData);
    } else {
        return request.post(`/api/v1/business/recruitment/${recruitmentId}/process-template/generate`);
    }
};
/**
 * 生成面试方案
  POST /api/v1/business/recruitment/interview-plan/generate
  接口ID：348109473
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-348109473
 */
  export const generateInterviewPlanSaveApi =(data)=>request.post(`/api/v1/business/recruitment/interview-plan/save`,data);
  /** 
   * 获取最新的远程任务
  GET /api/v1/business/remote-task/latest
  接口ID：352389909
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-352389909
  */
  export const getTaskLatestApi =()=>request.get(`/api/v1/business/remote-task/latest`);

  /**
 * 根据JD生成面试需求
  POST /api/v1/business/recruitment/generate
  接口ID：381036352
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-381036352
 */
export const subPositionNameApi = (data, signal) => request.post(`/api/v1/business/recruitment/generate`, data, { signal })


/**
 * 取消生成招聘需求
  POST /api/v1/business/recruitment/generate/cancel
  接口ID：403263023
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-403263023
 */
export const cancelSubPositionNameApi = (data) => request.post(`/api/v1/business/recruitment/cancel`, data)

/**
 * 查询风险招聘需求列表
 * GET /api/v1/business/recruitment/risky
 * 接口ID：406194155
 * 接口地址：https://app.apifox.com/link/project/5047271/apis/api-406194155
 */
export const getRiskyRecruitmentListApi = () => request.get(`/api/v1/business/recruitment/risky`)

/**
 * 查询正常推进的招聘需求列表（分页）
 * GET /api/v1/business/recruitment/normal
 * 接口ID：406194156
 * 接口地址：https://app.apifox.com/link/project/5047271/apis/api-406194156
 * @param {number} [pageSize] - 分页大小
 * @param {number} [pageNum] - 当前页码
 */
export const getNormalRecruitmentListApi = (pageSize, pageNum) => {
    const params = {}
    if (pageSize !== undefined && pageSize !== null) {
        params.pageSize = pageSize
    }
    if (pageNum !== undefined && pageNum !== null) {
        params.pageNum = pageNum
    }
    return request.get('/api/v1/business/recruitment/normal', { params })
}



